import { Data } from "Types/Reducers";
import { data as actions } from "actions";

const initialState = {
   temp_exhibition_idx: 0,
   v_name: "",
   email: "",
   hp: "",
   name: "", // 전시회 이름
   museum: 0, // 전시관 id
   museum_name: "",
   startdate: "",
   enddate: "",
   runtime: "",
   author: "", //@9596,@649
   author_array: {},
   authorplus: "", // ,로 구분한 작가들 이름
   exh_homepage: "",
   file2: "",
   files: "",
   temp_files: [],
   exhibition_id: 0,
   bank_name: "농협 351-1197-219093 아트맵 주식회사",
   order_code: "",
   acount_holder: "",
   should_cash_receipt: null,
   is_ordered: null,
   is_inserted: null,
   is_sent: null,
   temp_autoBackup: true,
};

function data(state = initialState, { type, payload }: { type: typeof actions[keyof typeof actions]; payload: any }): Data {
   switch (type) {
      case actions.set:
         const data = {
            ...state,
            ...payload,
         };
         return {
            ...data,
            files: data.temp_files.join(","),
         };
      default:
         return state;
   }
}

export { actions };
export { data };
